import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Explainer from "@/pages/Explainer";
import Walkthrough from "@/pages/Walkthrough";
import Sandbox from "@/pages/Sandbox";
import Evidence from "@/pages/Evidence";
import AssessorScript from "@/pages/AssessorScript";
import SnapshotView from "@/pages/SnapshotView";
import EvidencePrint from "@/pages/EvidencePrint";
import PublicReceipt from "@/pages/PublicReceipt";
import Diagnostics from "@/pages/Diagnostics";

function Footer() {
  return (
    <footer className="border-t border-[var(--line)] mt-12 bg-white fc-no-print">
      <div className="max-w-[1400px] mx-auto px-6 py-6 flex flex-wrap items-center justify-between gap-3 text-[12px] text-[var(--ink-soft)]">
        <div>
          <span className="display text-[var(--ink)]">FreightCierge</span>
          <span className="fc-divider-dot"/>
          Pilot sandbox for the Freight Innovation Fund
        </div>
        <div className="mono">CAR runtime · KATLAS node · Attributable receipts</div>
      </div>
    </footer>
  );
}

function Chrome({ children }) {
  const { pathname } = useLocation();
  // Snapshot routes, /r/<hash> public receipts, and print routes get their own chrome.
  const isSnapshot = pathname.startsWith("/snapshot/");
  const isPrint    = pathname.endsWith("/print") || pathname === "/evidence/print";
  const isReceipt  = pathname.startsWith("/r/");
  if (isPrint) return <>{children}</>;
  return (
    <>
      {!isSnapshot && !isReceipt && <Nav />}
      <main>{children}</main>
      {!isSnapshot && !isReceipt && <Footer />}
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Chrome>
          <Routes>
            <Route path="/" element={<Explainer />} />
            <Route path="/walkthrough" element={<Walkthrough />} />
            <Route path="/sandbox" element={<Sandbox />} />
            <Route path="/sandbox/diagnostics" element={<Diagnostics />} />
            <Route path="/evidence" element={<Evidence />} />
            <Route path="/evidence/print" element={<EvidencePrint />} />
            <Route path="/script" element={<AssessorScript />} />
            <Route path="/snapshot/:token" element={<SnapshotView />} />
            <Route path="/snapshot/:token/print" element={<EvidencePrint />} />
            <Route path="/r/:hash" element={<PublicReceipt />} />
          </Routes>
        </Chrome>
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}
